import React from 'react';
import { Header } from '../components/Header';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { ArrowLeftIcon, PlusIcon } from 'lucide-react';
interface MembersScreenProps {
  onBack: () => void;
  onLogout: () => void;
}
export function MembersScreen({
  onBack,
  onLogout
}: MembersScreenProps) {
  const members = [{
    email: 'partner@smithfirm.com',
    role: 'Admin',
    access: 'Full',
    date: 'Oct 12, 2023'
  }, {
    email: 'associate1@smithfirm.com',
    role: 'Reviewer',
    access: 'Assigned Batches',
    date: 'Oct 14, 2023'
  }, {
    email: 'paralegal@smithfirm.com',
    role: 'Enricher',
    access: 'Full',
    date: 'Oct 15, 2023'
  }, {
    email: 'contract.attorney@external.com',
    role: 'Reviewer',
    access: 'Assigned Batches',
    date: 'Nov 02, 2023'
  }];
  const getRoleBadge = (role: string) => {
    switch (role) {
      case 'Admin':
        return 'amber';
      case 'Reviewer':
        return 'blue';
      case 'Enricher':
        return 'teal';
      default:
        return 'default';
    }
  };
  return <div className="min-h-screen flex flex-col bg-navy" data-id="element-691">
      <Header caseName="Smith v. Acme Corp" onLogout={onLogout} data-id="element-692" />

      <main className="flex-1 p-8 max-w-5xl mx-auto w-full" data-id="element-693">
        <button onClick={onBack} className="flex items-center text-sm text-gray-400 hover:text-white mb-6 transition-colors" data-id="element-694">
          <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-695" />
          Back to Case Overview
        </button>

        <div className="flex items-start justify-between mb-8" data-id="element-696">
          <div data-id="element-697">
            <h1 className="text-3xl font-serif text-white mb-2" data-id="element-698">Case Access</h1>
            <p className="text-gray-400" data-id="element-699">
              Manage who can access Smith v. Acme Corp.
            </p>
          </div>
          <Button className="gap-2" data-id="element-700">
            <PlusIcon className="w-4 h-4" data-id="element-701" />
            Add User
          </Button>
        </div>

        <div className="bg-navy-light border border-navy-lighter rounded-lg overflow-hidden" data-id="element-702">
          <div className="grid grid-cols-[2fr_1fr_1.5fr_1fr_80px] gap-4 px-6 py-4 border-b border-navy-lighter bg-navy text-xs font-semibold text-gray-400 uppercase tracking-wider" data-id="element-703">
            <div data-id="element-704">Email</div>
            <div data-id="element-705">Role</div>
            <div data-id="element-706">Case Access</div>
            <div data-id="element-707">Date Granted</div>
            <div className="text-right" data-id="element-708">Action</div>
          </div>

          <div className="divide-y divide-navy-lighter" data-id="element-709">
            {members.map((member, i) => <div key={i} className="grid grid-cols-[2fr_1fr_1.5fr_1fr_80px] gap-4 px-6 py-4 items-center text-sm hover:bg-navy-hover transition-colors" data-id="element-710">
                <div className="text-white font-medium" data-id="element-711">{member.email}</div>
                <div data-id="element-712">
                  <Badge variant={getRoleBadge(member.role)} data-id="element-713">
                    {member.role}
                  </Badge>
                </div>
                <div className="text-gray-300" data-id="element-714">{member.access}</div>
                <div className="text-gray-400" data-id="element-715">{member.date}</div>
                <div className="text-right" data-id="element-716">
                  <button className="text-red-400 hover:text-red-300 text-sm transition-colors" data-id="element-717">
                    Remove
                  </button>
                </div>
              </div>)}
          </div>
        </div>

        <p className="mt-4 text-xs text-gray-500 text-center" data-id="element-718">
          Contact support to modify role permissions.
        </p>
      </main>
    </div>;
}